export const RESET_SCRIPTS = "RESET_SCRIPTS";
export const RESET_SCRIPT = "RESET_SCRIPT";
export const RESET_ERROR = "SCRIPTS_RESET_ERROR";

export const GET_SCRIPTS = "GET_SCRIPTS";
export const SET_SCRIPTS = "SET_SCRIPTS";

export const API_ERROR = "SCRIPTS_API_ERROR";

export const GET_SCRIPT = "GET_SCRIPT";
export const SET_SCRIPT = "SET_SCRIPT";

export const EDIT_SCRIPT = "EDIT_SCRIPT";
export const EDIT_SCRIPT_SUCCESS = "EDIT_SCRIPT_SUCCESS";

export const CREATE_SCRIPT = "CREATE_SCRIPT";
export const CREATE_SCRIPT_SUCCESS = "CREATE_SCRIPT_SUCCESS";

export const DELETE_SCRIPT = "DELETE_SCRIPT";
export const DELETE_SCRIPT_SUCCESS = "DELETE_SCRIPT_SUCCESS";
